import classNames from 'classnames'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import UserModel, {
  AccountModel,
  login,
  oldLogin,
  regOld,
  setUser,
} from '../../../../stores/UserModel'
import { ReactComponent as Gmail } from '../../../../assets/socials/gmail.svg'
import { ReactComponent as Eye } from '../../../../assets/login/eye.svg'
import { ReactComponent as CloseEye } from '../../../../assets/login/eye-off.svg'
import { ReactComponent as Check } from '../../../../assets/reg/check.svg'
import FacebookLogin from 'react-facebook-login'
import './index.scss'
import { useNavigate } from 'react-router'
import { GoogleLogin } from '@react-oauth/google'
import jwt_decode from 'jwt-decode'
import GlobalState from '../../../../stores/GlobalState'
import { CAPTCHA } from '../../../../mocks/doman'

export const ReCAPTCHAv3Utils = (
  action: string,
  onSuccess: any,
  onError: any,
) => {
  if ((window as any).grecaptcha) {
    ;(window as any).grecaptcha.ready(function () {
      var config = {
        action: action,
      }
      try {
        var query = (window as any).grecaptcha.execute(CAPTCHA, config)
        if (onSuccess) {
          query.then(onSuccess)
        }
      } catch (e) {
        var message = (e && (e as any).message) || 'Captcha request error.'
        if (onError) {
          onError(message)
        }
      }
    })
  } else {
    if (onError) {
      onError('reCAPTCHA v3 is not loaded correctly.')
    }
  }
}
const FirstStep = observer(
  ({
    content,
    setStep,
    isAuth,
    setEmail,
  }: {
    content: any
    setStep: () => void
    isAuth: boolean
    setEmail: (value: string) => void
  }) => {
    const [loginError, setError] = useState('')
    const navigate = useNavigate()
    const [state, setState] = useState({
      email: '',
      password: '',
      showPass: false,
      isCheck: false,
    })

    const [errs, setErrors] = useState({
      check: false,
      email: false,
      password: false,
    })

    const [errorMessages, setErrorMessages] = useState({
      check: '',
      email: '',
      password: '',
    })

    const emailValidate = (email: string) => {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
    }

    const submit = () => {
      const ers: any = {
        check: !state.isCheck,
        email: state.email.length && emailValidate(state.email) ? false : true,
        password: state.password.length ? false : true,
      }

      const ersText: any = {
        empty: GlobalState.currentLocale.lang.includes('En')
          ? 'Fill field'
          : GlobalState.currentLocale.lang.includes('ру')
          ? 'Заполните поле'
          : 'Заповніть поле',
        invalid: GlobalState.currentLocale.lang.includes('En')
          ? 'Invalid email'
          : GlobalState.currentLocale.lang.includes('ру')
          ? 'Некорректный email'
          : 'Некоректний email',
      }

      const ersMes: any = {
        email:
          state.email.length && emailValidate(state.email)
            ? ''
            : !state.email.length
            ? ersText.empty
            : ersText.invalid,
        password: state.password.length ? '' : ersText.empty,
      }

      if (ers.email || ers.password) {
        setError('')
        setErrors(ers)
        setErrorMessages({ ...errorMessages, ...ersMes })
        return
      }
      if (isAuth) {
        var onSuccess = function (token: any) {
          const response = oldLogin(state.email, state.password, token)
          response.then((result) => {
            if (result != 0) {
              if (state.isCheck) {
                localStorage.setItem('user-np', JSON.stringify(UserModel.user))
              } else {
                sessionStorage.setItem(
                  'user-np',
                  JSON.stringify(UserModel.user),
                )
              }
              setUser(state.email)
              let lang = GlobalState.currentLocale.lang.includes('En')
                ? '/en'
                : GlobalState.currentLocale.lang.includes('ру')
                ? '/ru'
                : ''

              window.location.href = `${lang}/account`
            } else {
              setError(content.errorText)
              setErrors({
                ...errs,
                email: true,
                password: true,
              })
            }
          })
        }
        var onError = function (message: any) {
          alert('Error: ' + message)
        }
        ReCAPTCHAv3Utils('login', onSuccess, onError)
      } else {
        var onSuccess = function (token: any) {
          const response = regOld(state.email, state.password, token)
          response.then((result) => {
            if (result) {
              setUser(state.email)

              setEmail(state.email)
              if (!isAuth) setStep()
            } else {
              setError(content.errorText)
              setErrors({
                ...errs,
                email: true,
                password: true,
              })
            }
          })
        }
        var onError = function (message: any) {
          alert('Error: ' + message)
        }
        ReCAPTCHAv3Utils('registr', onSuccess, onError)
      }
    }

    useEffect(() => {
      if (state.email.length && emailValidate(state.email)) {
        setErrors({
          ...errs,
          email: false,
        })

        setErrorMessages({
          ...errorMessages,
          email: '',
        })
      }
    }, [state.email])

    useEffect(() => {
      if (state.password.length) {
        setErrors({
          ...errs,
          password: false,
        })
        setErrorMessages({
          ...errorMessages,
          password: '',
        })
      }
    }, [state.password])

    const googleLogin = async (credit: any) => {
      var decodedHeader: any = jwt_decode(credit)
      oldLogin(decodedHeader.email, 'f', '').then(() => {
        setUser(decodedHeader.email)
        let lang = GlobalState.currentLocale.lang.includes('En')
          ? '/en'
          : GlobalState.currentLocale.lang.includes('ру')
          ? '/ru'
          : ''

        window.location.href = `${lang}/account`
      })
    }

    const responseFacebook = (response: any) => {
      if (!response.email) return
      oldLogin(response.email, 'f', '').then(() => {
        setUser(response.email)
        let lang = GlobalState.currentLocale.lang.includes('En')
          ? '/en'
          : GlobalState.currentLocale.lang.includes('ру')
          ? '/ru'
          : ''

        window.location.href = `${lang}/account`
      })
    }

    return (
      <div className="login-content2__content">
        <div className="login-content2__title">{content.title}</div>
        <div className="login-content2__row">
          <div className="login-content2__col ">
            <div
              className={classNames(
                'login-content2__input',
                errs.email && 'error',
                state.email.length && !errs.email && 'fill',
              )}
            >
              <input
                placeholder="Email"
                className="input"
                type="email"
                onChange={(e) => setState({ ...state, email: e.target.value })}
                value={state.email}
              />
              <p className="error-text">{errorMessages.email}</p>
            </div>
            <div
              className={classNames(
                'login-content2__input',
                errs.password && 'error',
                state.password.length && !errs.password && 'fill',
              )}
            >
              <input
                placeholder={content.passwordLabel}
                className="input"
                type={!state.showPass ? 'password' : 'text'}
                onChange={(e) =>
                  setState({ ...state, password: e.target.value })
                }
                value={state.password}
              />
              <p className="error-text">{errorMessages.password}</p>
              {state.showPass ? (
                <Eye onClick={() => setState({ ...state, showPass: false })} />
              ) : (
                <CloseEye
                  onClick={() => setState({ ...state, showPass: true })}
                />
              )}
            </div>
            {loginError.length ? (
              <div className="login-content2__error">{loginError}</div>
            ) : (
              <></>
            )}
            {isAuth && (
              <div className="login-content2__subrow">
                {' '}
                <div
                  className="reg-start__submit"
                  onClick={() =>
                    setState({ ...state, isCheck: !state.isCheck })
                  }
                >
                  <div
                    className={classNames(
                      'reg-start__submit-check',
                      state.isCheck && 'checked',
                    )}
                  >
                    <Check />
                  </div>
                  <div className="login-content2__text">
                    {content.rememberText}
                  </div>
                </div>
                <div className="login-content2__text hover" onClick={setStep}>
                  {content.forgotPass}
                </div>
              </div>
            )}
            {!isAuth && (
              <p
                className={classNames('login-content2__text', !isAuth && 'reg')}
                dangerouslySetInnerHTML={{ __html: content.text }}
              ></p>
            )}

            {isAuth ? (
              <div className="button black" onClick={submit}>
                {content.loginText}
              </div>
            ) : (
              <div className="button black" onClick={submit}>
                {content.registrText}
              </div>
            )}
          </div>
          <div className="login-content2__col ">
            <div className="login-content2__text">
              {content.loginBySocial.title}
            </div>

            <FacebookLogin
              appId="422976673114055"
              autoLoad={false}
              fields="name,email,picture"
              scope="public_profile,user_birthday,email"
              callback={responseFacebook}
              icon="fa-facebook"
              cssClass="login-content2__social"
              textButton={content.loginBySocial.fbText}
            />

            <div className="login-content2__social-cont">
              <div className="login-content2__social google">
                <Gmail /> {content.loginBySocial.googleText}
              </div>
              <GoogleLogin
                text={content.loginBySocial.googleText}
                onSuccess={(response) => {
                  googleLogin((response as any).credential)
                }}
                onError={() => console.log('error')}
              />
            </div>

            <div className="login-content2__text noaccount">
              {isAuth ? content.noaccount : content.accountText}
            </div>
            <div
              className="button grey-border"
              onClick={() => {
                let lang = GlobalState.currentLocale.lang.includes('En')
                  ? '/en'
                  : GlobalState.currentLocale.lang.includes('ру')
                  ? '/ru'
                  : ''
                navigate(isAuth ? `${lang}/reg` : `${lang}/login`)
              }}
            >
              {isAuth ? content.registrText : content.loginText}
            </div>
          </div>
        </div>
      </div>
    )
  },
)

export default FirstStep
